import { M3PrdGeneral } from "./M3PrdGeneral.type";
import { M3PrdAdicionales } from "./M3PrdAdicionales.type";
import { M3PrdPackByTipo } from "./m3-pack-by-tipo";
import { M3PUnidMedida } from "./m3p-unid-medida";
import { M3PrdGrpAsociado } from "./M3PrdGrpAsociado";

export class TypeM3PrdGrp {
    SKP1: string;
    RATING: number;
    FICHATECNICA: string;
    MARCA: string;
    CLASIFICACION: string;
    NOMBRE: string;
    TIPO: string;
    Cantidad: number;
    CamposAdicionales: string;
    LoM3PrdGeneral = new Array<M3PrdGeneral>();
    LoM3PrdAdicionales = new Array<M3PrdAdicionales>();
    M3PACKBYTIPO = new Array<M3PrdPackByTipo>();
    M3PrdGrpAsociado:Array<M3PrdGrpAsociado> = null;

    listImagenes = new Array<any>();
    Impuestos = new Array<TypeImpuestosPRD>();
    M3PUnidMedida: M3PUnidMedida;

    encontradoLocal: boolean = true;


    constructor() {


    }


}

export class TypeImpuestosPRD {
    CodImp: string;
    Metodologia: string;
    Valor: string
}